/**
 * 一覧の並び替えキー。API の sortKey クエリパラメータと同じ値を使う。
 */
export const orderSortKey = {
  createdAt: "createdAt",
  searchStatus: "searchStatus",
} as const;

export type OrderSortKey = (typeof orderSortKey)[keyof typeof orderSortKey];
